/**
 * Console banner
 *
 * Printed once when the app boots, so anyone who opens the browser devtools
 * sees a short greeting instead of a blank console.
 */

const TITLE = 'Selamat datang di Dekacare!'

const LINES = [
  'Sistem Informasi Manajemen atau biasa disebut Dekacare adalah Sistem Informasi yang dikembangkan oleh PT Dekate untuk membantu Fasyankes dalam melakukan pencatatan dan pengelolaan data pelayanan secara elektronik.',
  'Untuk informasi lebih lanjut silahkan hubungi tim Dekate.'
]

const TITLE_STYLE = [
  'font-family: Consolas, Monaco, "Courier New", monospace',
  'font-size: 28px',
  'font-weight: 700',
  'color: #7367f0',
  'padding: 6px 0'
].join(';')

const BODY_STYLE = [
  'font-family: Consolas, Monaco, "Courier New", monospace',
  'font-size: 12px',
  'line-height: 1.6',
  'color: #b4b7bd'
].join(';')

let printed = false

export default function printConsoleBanner() {
  if (printed) return
  printed = true

  try {
    console.log(`%c${TITLE}`, TITLE_STYLE)
    LINES.forEach((line) => console.log(`%c${line}`, BODY_STYLE))
  } catch (error) {
    // Console styling not supported - ignore
  }
}
